<div class="row text-center">

  <div class="title">
    {{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}
  </div>
  <div class="button-row">



    <div class="btn-group">
      <button mat-button class="calendar-button"  mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>arrow_back_ios_new</mat-icon>
      </button>
      <button mat-button class="calendar-button"  mwlCalendarToday [(viewDate)]="viewDate">
        <mat-icon>today</mat-icon>
      </button>
      <button mat-button class="calendar-button"  mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
    </div>
    <mat-button-toggle-group class="toggle-group" [(ngModel)]="view">
      <mat-button-toggle class="button-toggle" (click)="setView(CalendarView.Day)" value="day">
        <mat-icon>calendar_view_day</mat-icon><br>
        Day
      </mat-button-toggle>
      <mat-button-toggle class="button-toggle" (click)="setView(CalendarView.Week)" value="week">
        <mat-icon>calendar_view_week</mat-icon><br>
        Week
      </mat-button-toggle>
      <mat-button-toggle class="button-toggle" (click)="setView(CalendarView.Month)" value="month">
        <mat-icon>calendar_view_month</mat-icon><br>
        Month
      </mat-button-toggle>


    </mat-button-toggle-group>
  </div>
  <br />
  <div [ngSwitch]="view">
    <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
       [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)" (eventClicked)="handleEvent('Clicked', $event.event)"
      (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-month-view>
    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [dayStartHour]="startTime"
      [dayEndHour]="endTime" [events]="events" [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
      (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-week-view>
    <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [dayStartHour]="startTime"
      [dayEndHour]="endTime" [events]="events" [refresh]="refresh" (eventClicked)="handleEvent('Clicked', $event.event)"
      (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-day-view>
  </div>

  <!-- Everything you see below is just for the demo, you don't need to include it in your app -->
  <!--
<br /><br /><br />

<h3>
  Edit events
  <button class="btn btn-primary float-end" (click)="addEvent()">
    Add new
  </button>
  <div class="clearfix"></div>
</h3>

<div class="table-responsive">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Title</th>
        <th>Primary color</th>
        <th>Secondary + text color</th>
        <th>Starts at</th>
        <th>Ends at</th>
        <th>Remove</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let event of events">
        <td>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="event.title"
            (keyup)="refresh.next()"
          />
        </td>
        <td>
          <input
            type="color"
            [(ngModel)]="event.color.primary"
            (change)="refresh.next()"
          />
        </td>
        <td>
          <input
            type="color"
            [(ngModel)]="event.color.secondary"
            (change)="refresh.next()"
          />
          <input
            type="color"
            [ngModel]="'#1e90ff'"
            (ngModelChange)="event.color.secondaryText = $event"
            (change)="refresh.next()"
          />
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            mwlFlatpickr
            [(ngModel)]="event.start"
            (ngModelChange)="refresh.next()"
            [altInput]="true"
            [convertModelValue]="true"
            [enableTime]="true"
            dateFormat="Y-m-dTH:i"
            altFormat="F j, Y H:i"
            placeholder="Not set"
          />
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            mwlFlatpickr
            [(ngModel)]="event.end"
            (ngModelChange)="refresh.next()"
            [altInput]="true"
            [convertModelValue]="true"
            [enableTime]="true"
            dateFormat="Y-m-dTH:i"
            altFormat="F j, Y H:i"
            placeholder="Not set"
          />
        </td>
        <td>
          <button class="btn btn-danger" (click)="deleteEvent(event)">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div> -->

  <ng-template #modalContent let-close="close">
    <div class="modal-header">
      <h5 class="modal-title">Event action occurred</h5>
      <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        Action:
        <pre>{{ modalData?.action }}</pre>
      </div>
      <div>
        Event:
        <pre>{{ modalData?.event | json }}</pre>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">
        OK
      </button>
    </div>
  </ng-template>
